<ng-container *ngIf="!!translation && !!menu  && !!translationTFooter">
    <navigation-menu [menu]="menu" [sidePage]="!isHome" [sideLangs]="sideLangs" (scrollingTarget)="scrollTo($event)" (languageTarget)="updateLangs($event)"></navigation-menu>
    <page-gen [sls]="translation" (SL00Data)="scrollTo($event)" (SL11Data)="scrollTo($event)"  (SL22Data)="scrollTo($event)" (SL01Data)="scrollTo($event)" (SL06Data)="scrollTo($event)" (SL08Data)="scrollTo($event)" (SL09Data)="scrollTo($event)" (SL18Data)="scrollTo($event)" (SL19Data)="scrollTo($event)" (SL23Data)="scrollTo($event)" ></page-gen>
    <app-topfooter [translation]="translationTFooter" [minimal]="!isHome"></app-topfooter>
    <app-footer></app-footer>    
</ng-container>


